module.exports = __webpack_public_path__ + "static/media/close.8e640708.svg";